
angular.module('picsPreviewRebuildModule', []).directive('picsPreview', [
    function () {
        return {
            scope: {
                picList: '='
            }, // 继承作用域
            restrict: 'EA',
            templateUrl: './utils/picsPreview/picsPreview.html',
            replace: true,
            link: function ($scope) {
            },
        };
    },
]);
